import React from 'react';
import _, { toUpper } from 'lodash';
import base64 from 'base-64';
import classnames from 'classnames';
import ReactTable from 'react-table-6';
import history from 'app/routes/history';
import 'react-table-6/react-table.css';

import Loader from 'app/components/general/Loader';
import TableFilter from 'app/components/general/TableFilter';

interface ITableProps {
  data: any[];
  columns: any[];
  pagination: object;
  className: string;
  sectionClassName: string;
  objectTitle: string;
  headerTitle: string;
  filterTitle: string;
  counterText: string;
  filterOptions: any[];
  filterConfig: object;
  persistentFilterConfig: any;
  children: React.ReactNode;
  handleClick: any;
  saveFilters: boolean;
  filterable: boolean;
  showPagination: boolean;
  showChildren: boolean;
  isLoading: boolean;
  aggressiveLoader: boolean;
  manual: boolean;
  onFetchData: any;
  page: number;
}

interface ITableState {
  filterConfig: any;
  appliedFilterConfig: any;
  selectedOptions: any;
  changed: boolean;
  filtersApplied: boolean;
}
export default class Table extends React.Component<ITableProps, ITableState> {
  static defaultProps: ITableProps = {
    data: [],
    columns: [],
    pagination: {
      page: {
        size: 25,
        number: 0,
      },
      filter: [],
      sort: [],
      meta: {
        totalCount: undefined,
        totalPages: undefined,
      },
    },
    objectTitle: undefined,
    headerTitle: undefined,
    filterTitle: undefined,
    filterOptions: undefined,
    sectionClassName: undefined,
    className: undefined,
    filterConfig: undefined,
    counterText: undefined,
    persistentFilterConfig: {},
    children: undefined,
    handleClick: undefined,
    filterable: true,
    showChildren: false,
    showPagination: true,
    isLoading: false,
    aggressiveLoader: false,
    manual: false,
    onFetchData: undefined,
    page: undefined,
  };

  state = {
    filterConfig: this.props.filterConfig || {},
    selectedOptions: {},
    appliedFilterConfig: undefined,
    changed: false,
    filtersApplied: false,
  };

  static getDerivedStateFromProps(nextProps, prevState): any {
    if (!prevState.changed) {
      return {
        filterConfig: {
          ...nextProps.filterConfig,
          ...nextProps.persistentFilterConfig,
        },
        selectedOptions: _.mapValues(nextProps.filterConfig, () => true),
      };
    }
    return null;
  }

  componentDidMount = (): void => {
    if (this.props.filterConfig !== undefined || this.props.persistentFilterConfig !== undefined) {
      this.applyFilters();
    } else {
      this.setState({ filtersApplied: true });
    }
  }

  componentDidUpdate = (prevProps): void => {
    // console.log(`${JSON.stringify(this.props.filterConfig)} not equal ${JSON.stringify(prevProps.filterConfig)}`);
    if (
      (this.props.filterConfig !== undefined
        && !_.isEqual(prevProps.filterConfig, this.props.filterConfig))
      || (this.props.persistentFilterConfig !== undefined
        && !_.isEqual(
          prevProps.persistentFilterConfig,
          this.props.persistentFilterConfig,
        ))
    ) {
      this.applyFilters();
    }
  }

  handleFilterChange = (e: any, name = null, type = null) => {
    if (e !== null && _.isFunction(e.persist)) {
      e.persist();
    }
    // console.log(e.target.value, name);
    // console.log(e);
    // console.log(name);
    // console.log(type);
    if (e === null) {
      this.setState((prevState) => {
        const config = _.omit(
          {
            ...prevState.filterConfig,
          },
          name,
        );

        return { changed: true, filterConfig: config };
      });
    } else if (type === 'datetime') {
      this.setState((prevState) => {
        const config = {
          ...prevState.filterConfig,
          [name]: _.map(e, (f) => f.toString()),
        };
        // console.log(config);
        return { changed: true, filterConfig: config };
      });
    } else if (type === 'currency') {
      this.setState((prevState) => {
        const config = {
          ...prevState.filterConfig,
          [name]: e.formattedValue,
        };
        // console.log(config);
        return { changed: true, filterConfig: config };
      });
    } else if (e.target === undefined) {
      this.setState((prevState) => {
        const config = {
          ...prevState.filterConfig,
          [name]: e,
        };

        return { changed: true, filterConfig: config };
      });
    } else if (_.isEmpty(e.target.value) || e.target.value === '') {
      this.setState((prevState) => {
        const config = _.omit(
          {
            ...prevState.filterConfig,
          },
          e.target.name,
        );

        return { changed: true, filterConfig: config };
      });
    } else {
      this.setState((prevState) => {
        const config = {
          ...prevState.filterConfig,
          [e.target.name]: e.target.value,
        };

        return { changed: true, filterConfig: config };
      });
    }
  };

  toggleFilterOption = (accessor): void => {
    this.setState((prevState) => {
      const toggleValue = prevState.selectedOptions[accessor] === undefined
        ? true
        : !prevState.selectedOptions[accessor];
      const newSelectedOptions = {
        selectedOptions: {
          ...prevState.selectedOptions,
          [accessor]: toggleValue,
        },
        changed: true,
      };
      this.handleFilterToggleChange(accessor, toggleValue);

      return newSelectedOptions;
    });
  };

  handleFilterToggleChange = (accessor, toggleOption) => {
    if (!toggleOption) {
      this.setState((prevState) => {
        const config = _.omit(
          {
            ...prevState.filterConfig,
          },
          accessor,
        );

        return { changed: true, filterConfig: config };
      });
    }
  };

  clearFilters = () => {
    this.setState({
      changed: true,
      filterConfig: {},
      appliedFilterConfig: [],
    });
    if (history.location.pathname.split(':')[1] !== undefined) {
      history.push(history.location.pathname.split(':')[0]);
    }
  };

  applyFilters = () => {
    this.setState((prevState) => {
      const appliedFilterConfig = _.flatMap(
        prevState.filterConfig,
        (value: any, key) => {
          // console.log(value);
          // console.log(key);
          // if (_.isArray(value)) {
          //   return _.map(value, (innerValue, innerKey) => {
          //     const innerParsedValue = _.isObject(innerValue)
          //       ? innerValue.name
          //       : innerValue;
          //     return { id: key, value: innerParsedValue };
          //   });
          // }
          // console.log(value, _.isObject(value));
          const parsedValue = _.isObject(value) && value.id !== undefined ? value.id : value;
          // console.log({ id: key, value: parsedValue });
          return { id: key, value: parsedValue };
        },
      );
      // console.log(this.props.saveFilters);
      // console.log(prevState.filterConfig);
      if (this.props.saveFilters && !_.isEmpty(prevState.filterConfig)) {
        const filterConfigEncoded = base64.encode(JSON.stringify(prevState.filterConfig));
        // console.log(filterConfigEncoded);
        // console.log(history.location);
        history.push(`${history.location.pathname.split(':')[0]}:${filterConfigEncoded}`);
      }

      return {
        filtersApplied: true,
        appliedFilterConfig,
      };
    });
  };

  renderApiTable = (): React.ReactNode => {
    if (this.props.isLoading && (this.props.aggressiveLoader || _.isEmpty(this.props.data))) {
      return (
        <div className="table-loading">
          <Loader skeleton height={25} count={5} isActive color="grey" />
        </div>
      );
    }

    return (
      <ReactTable
        className={classnames(
          'section-table',
          {
            'no-data':
              this.props.data === undefined || this.props.data.length === 0,
          },
          {
            'no-pagination': !this.props.showPagination,
          },
          this.props.className,
        )}
        filterable={false}
        resizable={false}
        showPagination={this.props.showPagination}
        previousText="Back"
        nextText="Next"
        pageText=""
        data={this.props.data}
        noDataText={`No ${this.props.objectTitle} found`}
        minRows={1}
        // loading={this.props.isLoading}
        manual={this.props.manual}
        onFetchData={(props, state, instance) => this.props.onFetchData(props, state, instance, this.state)}
        sorted={this.props.pagination.sort}
        defaultPageSize={this.props.pagination.page.size}
        page={this.props.pagination.page.number}
        pages={this.props.pagination?.meta?.totalPages}
        defaultFiltered={this.state.appliedFilterConfig}
        columns={this.props.columns}
        getTdProps={(state, rowInfo, column, instance) => ({
          onClick: (e) => {
            if (
              this.props.handleClick !== undefined
              && !_.isEmpty(rowInfo.original)
              && !_.isEmpty(rowInfo.original.id)
            ) {
              // console.log(rowInfo.original.id);
              this.props.handleClick(rowInfo.original.id, rowInfo.original);
            }
          },
        })}
      />
    );
  };

  renderTable = (): React.ReactNode => {
    if (this.props.isLoading && (this.props.aggressiveLoader || _.isEmpty(this.props.data))) {
      return (
        <div className="table-loading">
          <Loader skeleton height={25} count={3} isActive color="grey" />
        </div>
      );
    }
    return (
      <ReactTable
        className={classnames(
          'section-table',
          {
            'no-data':
              this.props.data === undefined || this.props.data.length === 0,
          },
          {
            'no-pagination': !this.props.showPagination,
          },
          this.props.className,
        )}
        filterable={false}
        resizable={false}
        showPagination={this.props.showPagination}
        previousText="Back"
        nextText="Next"
        pageText=""
        data={this.props.data}
        noDataText={`No ${this.props.objectTitle} found`}
        minRows={1}
        // loading={this.props.isLoading}
        manual={false}
        defaultPageSize={this.props.defaultPageSize || 25}
        defaultFiltered={this.state.appliedFilterConfig}
        columns={this.props.columns}
        getTdProps={(state, rowInfo, column, instance) => ({
          onClick: (e) => {
            if (
              this.props.handleClick !== undefined
              && !_.isEmpty(rowInfo.original)
              && !_.isEmpty(rowInfo.original.id)
            ) {
              // console.log(rowInfo.original.id);
              this.props.handleClick(rowInfo.original.id);
            }
          },
        })}
      />
    );
  };

  render(): React.ReactNode {
    return (
      <div className={`section-group ${this.props.sectionClassName}`}>
        {(this.props.headerTitle !== undefined || this.props.filterable || this.props.children !== undefined) && (
          <div className="row section-title">
            {this.props.headerTitle !== undefined && (

              <div className="col section-title-col">
                <h3>{this.props.headerTitle}</h3>
              </div>
            )}
            {this.props.headerTitle === undefined && this.props.counterText !== undefined && (
              <div className="col col-6 text-left">
                <h4>
                  {this.props.counterText}
                </h4>
              </div>
            )}

            {(this.props.filterable || this.props.children !== undefined) && (
              <div className="col col-6 btn-flex-group">
                <div className="btn-flex-container thin-margin float-right">
                  {this.props.showChildren && this.props.children}
                  {this.props.filterable && (
                    <TableFilter
                      handleFilterChange={this.handleFilterChange}
                      handleFilterToggleChange={this.handleFilterToggleChange}
                      toggleFilterOption={this.toggleFilterOption}
                      clearFilters={this.clearFilters}
                      applyFilters={this.applyFilters}
                      filterConfig={this.state.filterConfig}
                      selectedOptions={this.state.selectedOptions}
                      persistentFilterConfig={this.props.persistentFilterConfig}
                      title={this.props.filterTitle}
                      filterOptions={this.props.filterOptions}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        )}
        <div className="row with-margin-top-10">
          <div className="col">
            <div className="divider full lesser-margin" />
          </div>
        </div>
        <div className="row">
          <div className="col">
            {this.props.manual ? this.renderApiTable() : this.renderTable()}
          </div>
        </div>
      </div>
    );
  }
}
